import TagsApi from 'app/api/TagsApi';
import TagsConstants from 'app/constants/TagsConstants';
import composeGlobalSuccessMessaging from 'app/helpers/messaging/composeGlobalSuccessMessaging';

function addTags(metadataId, tags, postSuccess) {
  return {
    metadataId,
    types: [TagsConstants.ADD_TAG_REQUEST, TagsConstants.ADD_TAG_SUCCESS, TagsConstants.ADD_TAG_FAILURE],
    middlewareData: {
      authRequired: true
    },
    postSuccess,
    apiRequest: (state, client) =>
      TagsApi.addTags(
        {
          tags,
          userId: state.getIn(['auth', 'currentUserId'])
        },
        client
      )
  };
}

function removeTagSuccess(tagId) {
  const messageId = 'message_successful_remove_tag';
  return {
    messaging: composeGlobalSuccessMessaging(messageId),
    deletedEntities: [`ugc.tags.${tagId}`]
  };
}

function removeTag(metadataId, tagId, type) {
  return {
    metadataId,
    tagId,
    types: [TagsConstants.REMOVE_TAG_REQUEST, TagsConstants.REMOVE_TAG_SUCCESS, TagsConstants.REMOVE_TAG_FAILURE],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) =>
      TagsApi.removeTag(
        {
          tagId,
          userId: state.getIn(['auth', 'currentUserId']),
          type
        },
        client
      ),
    apiSuccess: () => removeTagSuccess(tagId)
  };
}

function fetchTagSummaries(metadataId) {
  return {
    metadataId,
    types: [
      TagsConstants.FETCH_TAG_SUMMARIES_REQUEST,
      TagsConstants.FETCH_TAG_SUMMARIES_SUCCESS,
      TagsConstants.FETCH_TAG_SUMMARIES_FAILURE
    ],
    apiRequest: (state, client) => TagsApi.fetchTagSummaries(metadataId, client)
  };
}

function fetchOwnerTags(metadataIds) {
  return {
    metadataIds,
    types: [
      TagsConstants.FETCH_OWNER_TAGS_REQUEST,
      TagsConstants.FETCH_OWNER_TAGS_SUCCESS,
      TagsConstants.FETCH_OWNER_TAGS_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) => TagsApi.getUserTags(metadataIds, client)
  };
}

export default {
  addTags,
  removeTag,
  fetchTagSummaries,
  fetchOwnerTags
};
